(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.innerWidth <= 768;
    const hotspots = document.querySelectorAll('.sleep-shoppable-banner__hotspot');

    hotspots.forEach((hotspot) => {
      const point = hotspot.querySelector('.sleep-shoppable-banner__point');
      const popup = hotspot.querySelector('.sleep-shoppable-banner__popup');

      let showTimeout;
      let hideTimeout;

      const showPopup = () => {
        clearTimeout(hideTimeout);
        showTimeout = setTimeout(() => {
          popup.classList.add('sleep-shoppable-banner__popup--visible');
          positionPopup(hotspot, popup);
        }, 100);
      };

      const hidePopup = () => {
        clearTimeout(showTimeout);
        hideTimeout = setTimeout(() => {
          popup.classList.remove('sleep-shoppable-banner__popup--visible');
        }, 200);
      };

      const positionPopup = (hotspot, popup) => {
        const hotspotRect = hotspot.getBoundingClientRect();
        const popupRect = popup.getBoundingClientRect();
        const container = hotspot.closest('.sleep-shoppable-banner__image-wrapper');
        const containerRect = container.getBoundingClientRect();

        // Remove previous position classes
        popup.classList.remove('sleep-shoppable-banner__popup--left', 'sleep-shoppable-banner__popup--right');

        // Check if popup fits on the right
        if (hotspotRect.left + popupRect.width + 20 < containerRect.right) {
          popup.classList.add('sleep-shoppable-banner__popup--right');
        } else {
          popup.classList.add('sleep-shoppable-banner__popup--left');
        }
      };

      hotspot.addEventListener('mouseenter', showPopup);
      hotspot.addEventListener('mouseleave', hidePopup);

      popup.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout);
      });

      popup.addEventListener('mouseleave', hidePopup);
    });

    const popupVariants = document.querySelectorAll('.sleep-shoppable-banner__popup-variant-swatch');
    popupVariants.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        const popup = this.closest('.sleep-shoppable-banner__popup');
        const variantImage = this.getAttribute('data-variant-image');
        const variantUrl = this.getAttribute('data-variant-url');

        if (variantImage) {
          const productImage = popup.querySelector('.sleep-shoppable-banner__popup-image img');
          if (productImage) {
            productImage.src = variantImage;
          }
        }

        if (variantUrl) {
          const productLink = popup.querySelector('.sleep-shoppable-banner__popup-button');
          if (productLink) {
            productLink.href = variantUrl;
          }
        }

        const allSwatches = popup.querySelectorAll('.sleep-shoppable-banner__popup-variant-swatch');
        allSwatches.forEach((s) => s.classList.remove('sleep-shoppable-banner__popup-variant-swatch--active'));

        this.classList.add('sleep-shoppable-banner__popup-variant-swatch--active');
      });
    });

    const mobileToggle = document.querySelector('.sleep-shoppable-banner__mobile-toggle');
    const mobileCarousel = document.querySelector('.sleep-shoppable-banner__mobile-carousel');

    if (mobileToggle && mobileCarousel) {
      mobileToggle.addEventListener('click', function () {
        mobileCarousel.classList.toggle('sleep-shoppable-banner__mobile-carousel--visible');
        mobileToggle.classList.toggle('sleep-shoppable-banner__mobile-toggle--active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
